import { useState, useEffect } from 'react';

/* Single source of truth for the tracker panel breakpoint. Mirrors the
   existing Bootstrap lg breakpoint (800px in custom.scss) so the JS switch
   and the CSS @media blocks can't drift. */
export const TRACKER_PANEL_QUERY = '(min-width: 800px)';

export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            ? window.matchMedia(query).matches
            : false
    );

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return undefined;
        const mql = window.matchMedia(query);
        const onChange = (e) => setMatches(e.matches);
        if (mql.addEventListener) {
            mql.addEventListener('change', onChange);
        } else {
            mql.addListener(onChange); // Safari < 14
        }
        setMatches(mql.matches);
        return () => {
            if (mql.removeEventListener) {
                mql.removeEventListener('change', onChange);
            } else {
                mql.removeListener(onChange);
            }
        };
    }, [query]);

    return matches;
}

export default useMediaQuery;
